module.exports = __webpack_public_path__ + "img/avatar_1.621f433b.png";